var React = require('react');

function DropDownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.7783 4.98466L7.00622 9.21258L11.2341 4.98466C11.2483 4.97042 11.2637 4.95796 11.2799 4.94729C11.3931 4.87254 11.5469 4.88499 11.6466 4.98466C11.7605 5.09856 11.7605 5.28323 11.6466 5.39714L7.21243 9.83127C7.15777 9.88598 7.08357 9.91673 7.00622 9.91673C6.92887 9.91673 6.85467 9.88598 6.79996 9.83127L2.36582 5.39714C2.26705 5.29837 2.25393 5.14637 2.32647 5.03346C2.33757 5.01616 2.35069 4.99979 2.36582 4.98466C2.38006 4.97042 2.3954 4.95796 2.41157 4.94729C2.45065 4.92149 2.49455 4.90608 2.53941 4.90106C2.55026 4.89984 2.56116 4.89923 2.57206 4.89923C2.6467 4.89923 2.72135 4.92771 2.7783 4.98466Z","fill":"#121212"}));
}

DropDownArrow.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = DropDownArrow;

DropDownArrow.default = DropDownArrow;
